var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncreaseConversionRates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: 0.681,
    width: 30.639,
    height: 30.639,
    rx: 6.565,
    fill: "url(#increase_conversion_rates_svg__paint0_linear_440_8190)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.273 16c0 5.372 4.355 9.727 9.727 9.727s9.727-4.355 9.727-9.727S21.372 6.273 16 6.273 6.273 10.628 6.273 16zm8.999 6.512c0 .499.332.707.714.707.374 0 .707-.208.707-.707v-.665c2.236-.24 3.632-1.554 3.632-3.466 0-1.645-.99-2.642-3.042-3.091l-1.687-.383c-1.056-.232-1.571-.714-1.571-1.42 0-.848.731-1.464 1.878-1.464.931 0 1.58.316 2.303 1.122.365.383.648.524 1.03.524.465 0 .823-.324.823-.806 0-.466-.274-.973-.74-1.43-.615-.582-1.537-.964-2.576-1.097v-.69c0-.49-.333-.698-.715-.698-.374 0-.706.2-.706.698v.665c-2.153.2-3.524 1.488-3.524 3.333 0 1.613.989 2.685 2.884 3.109l1.687.39c1.23.291 1.737.723 1.737 1.455 0 .947-.74 1.546-2.061 1.546-.99 0-1.812-.374-2.56-1.18-.424-.425-.657-.516-.973-.516-.507 0-.889.324-.889.881 0 .49.283.997.79 1.438.665.607 1.703.98 2.859 1.089v.656z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "increase_conversion_rates_svg__paint0_linear_440_8190",
    x1: 0.681,
    y1: 0.681,
    x2: 0.681,
    y2: 31.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EDC9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DC463"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseConversionRates);
export default ForwardRef;